// All Feature Flag Portal change tracking goes here (flags, templates, entity ops), not in
// pages/featureFlags/sources.ts. IDs share the 130xx range with that file and must be unique across
// both; a duplicate throws at dev startup.
export const FEATURE_FLAG_PORTAL_CHANGE_TRACKING = {
  entityOpsBulkAssignment: {
    source: 'feature_flag_portal.entity_ops.bulk_assignment',
    id: 13013,
  },
  createFlag: {
    source: 'feature_flag_portal.create_flag',
    id: 13009,
  },
  updateFlag: {
    source: 'feature_flag_portal.update_flag',
    id: 13020,
  },
  impactedAreasUploadAttachment: {
    source: 'feature_flag_portal.flags.impacted_areas.attachments.upload',
    id: 13010,
  },
  impactedAreasAddAttachmentUrl: {
    source: 'feature_flag_portal.flags.impacted_areas.attachments.add_url',
    id: 13011,
  },
  impactedAreasDeleteAttachment: {
    source: 'feature_flag_portal.flags.impacted_areas.attachments.delete',
    id: 13012,
  },
  portalTemplateCreate: {
    source: 'feature_flags.portal.template.create',
    id: 13015,
  },
  portalTemplateUpdate: {
    source: 'feature_flags.portal.template.update',
    id: 13016,
  },
  portalTemplateDelete: {
    source: 'feature_flags.portal.template.delete',
    id: 13017,
  },
  portalTemplateAssign: {
    source: 'feature_flags.portal.template.assign',
    id: 13018,
  },
  portalTemplateUnassign: {
    source: 'feature_flags.portal.template.unassign',
    id: 13019,
  },
  portalTemplateReApply: {
    source: 'feature_flags.portal.template.re_apply',
    id: 13014,
  },
} as const;
